// @ts-nocheck
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import RefreshIcon from '@material-ui/icons/Autorenew';
import DeleteIcon from '@material-ui/icons/RemoveCircleOutline';
import RoleIcon from '@material-ui/icons/Security';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { PERMISSIONS, PERMISSION_ENTITIES, TABLE_HEADER_COLOR } from '../../_config/consts';
import { getColorFromThemeName } from '../../_config/utils';
import AbilityProvider from '../../permissionsUtils/AbilityProvider';
import * as GuestActions from '../../redux/actions/guest.actions';
import * as RolesActions from '../../redux/actions/roles.actions';
import SortIconCustom from '../CustomIcons/SortIconCustom.jsx';
import UnsortIconCustom from '../CustomIcons/UnsortIconCustom.jsx';
import UserCheckIconCustom from '../CustomIcons/UserCheckIconCustom.jsx';
import UserDisableIconCustom from '../CustomIcons/UserDisableIconCustom.jsx';
import UsersIconCustom from '../CustomIcons/UsersIconCustom.jsx';
import EmptyView from '../EmptyView.jsx';
import ListLoadingView from '../ListLoadingView.jsx';
import MDTablePaginationActions from '../MDTable/MDTablePaginationActions.jsx';

import * as InstallersActions from '../../redux/actions/installers.actions';
import SortAscendingIconCustom from '../CustomIcons/SortAscendingIconCustom.jsx';
import SortDescendingIconCustom from '../CustomIcons/SortDescendingIconCustom.jsx';

const styles = theme => ({
  table: {
    overflow: 'scroll',
  },
  tableColumnText: {
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  tableColumnHeader: {
    display: 'flex',
    flexDirection: 'row',
  },
  tableColumnHeaderText: {
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  tableColumnHeaderArrow: {
    padding: 10,
    marginLeft: 10,
  },
  tableColumnHeaderArrowIcon: {
    fontSize: 20,
    width: 20,
  },
  tableColumnHeaderSortIcon: {
    width: 24,
  },
  disabledInput: {
    display: 'none',
  },
  guestTag: {
    padding: 3,
  },
  rowSelected: {
    backgroundColor: 'aliceblue !important',
    color: 'aliceblue !important',
  },
  rowHovered: {
    cursor: 'pointer',
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
  button: {
    color: '#E53935',
    fontSize: 12,
    fontWeight: 'bold',
    textDecoration: 'underline',
  },
  actionContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  guestRowContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  rowWithAction: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  rowActionButton: {
    width: 45,
    height: 45,
  },
  rowActionButtonIcon: {
    fontSize: 20,
    color: '#E53935',
  },
  paginationText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
});

@connect((state) => ({ viewLoading: state.utils.viewLoading, companyConfigurations: state.user.companyConfigurations, installers: state.installers, themeName: state.settings.items.theme.data.themeName }))
class InstallersTableView extends React.Component {
  
  async handleOrderChange(column) {
    const { onOrderChanged, dispatch } = this.props;
    const { installers: { data: { sorting: {orderBy, orderDir} } } } = this.props;
    const orderDir_new = orderBy===column?(orderDir==='ASC'?'DESC':'ASC'):'ASC';
    await dispatch(InstallersActions.setOrder(column, orderDir_new));
    onOrderChanged()
  };

  async onResetOrder() {
    const { onOrderChanged, dispatch } = this.props;
    await dispatch(InstallersActions.setOrder(undefined, undefined));
    onOrderChanged()
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(GuestActions.setOperationalMode(false));
  }

  render() {
    const {
      classes,
      installers: { data: { content: installersData, pagination: { number: currentPage, size, totalPages, totalElements }, filters, sorting: {orderBy, orderDir} } },
      installers: { selectedUser },
      onDisableUserRequest,
      onResetUserPassword,
      onDeleteUserRequest,
      onFetchInstallersOnPage,
      onRefreshInstallers,
      onNewInstallerUser,
      viewLoading,
      onSelectUser,
      themeName
    } = this.props;
    const canCreateUser = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.CREATE], PERMISSION_ENTITIES.USER);
    const canDeleteUser = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.DELETE], PERMISSION_ENTITIES.USER);
    const canEditUser = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.UPDATE], PERMISSION_ENTITIES.USER);
    const headerColor = getColorFromThemeName(themeName);
    return (
      <div className="list-view details-section r-list-offset-custom" style={{ top: 320, paddingBottom: 200, width: '87%' }}>
        <div>
          {!_.isEmpty(installersData) ?
            <Card style={{ overflow: 'scroll' }} elevation={4}>
              <Table size="small" className={classes.table}>
                <TableHead>
                  <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                    <TableCell colSpan={2}>
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <h3 className={classes.tableColumnText} style={{ color: '#3f3f3f', marginTop: 15, marginBottom: 15 }}><Entity entity="installers" /></h3>
                        <IconButton onClick={() => onRefreshInstallers()} style={{ marginLeft: 10, marginTop: 5 }}>
                          <RefreshIcon style={{ color: '#3f3f3f', fontSize: 25 }} />
                        </IconButton>
                        {orderBy && 
                          <IconButton onClick={() => this.onResetOrder()} style={{ marginLeft: 5, marginTop: 5 }}>
                            <UnsortIconCustom style={{ color: '#3f3f3f', width: 25 }} />
                          </IconButton>
                        }
                      </div>
                    </TableCell>
                    <TablePagination
                      colSpan={2}
                      count={!_.isUndefined(totalElements) ? totalElements : 0}
                      rowsPerPage={!_.isUndefined(size) ? size : 0}
                      page={!_.isUndefined(currentPage) ? currentPage : 0}
                      labelRowsPerPage=" "
                      classes={{
                        input: classes.disabledInput,
                      }}
                      labelDisplayedRows={({ from, to, count }) => (
                        <h4 className={classes.paginationText}>
                          <Entity
                            key={`${from}-${totalPages}-${count}`}
                            entity="userTablePagination"
                            data={{
                              currentPage: !_.isUndefined(currentPage) ? currentPage + 1 : 0,
                              totalPages: !_.isUndefined(totalPages) ? totalPages : 0,
                              count: !_.isUndefined(count) ? count : 0,
                            }}
                          />
                        </h4>
                      )}
                      onChangePage={(event, page) => onFetchInstallersOnPage(page)}
                      ActionsComponent={() => (
                        <MDTablePaginationActions
                          count={totalElements}
                          iconColor="#3f3f3f"
                          page={currentPage}
                          lastPage={totalPages - 1}
                          rowsPerPage={size}
                          onChangePage={(event, page) => onFetchInstallersOnPage(page)}
                        />
                      )}
                    />
                    </TableRow>
                  <TableRow style={{ backgroundColor: 'white' }}>
                    <TableCell>
                      <div className={classes.tableColumnHeader}>
                        <h4 className={classes.tableColumnHeaderText}><Entity entity="user" /></h4>
                        {orderBy === 'email'?(
                          <IconButton onClick={() => this.handleOrderChange('email')} style={{opacity: 1}} className={classes.tableColumnHeaderArrow}>
                            {orderDir==='ASC'||orderBy!=='email'? <SortDescendingIconCustom className={classes.tableColumnHeaderArrowIcon}/> : <SortAscendingIconCustom className={classes.tableColumnHeaderArrowIcon}/>}
                          </IconButton>
                        ):(
                          <IconButton onClick={() => this.handleOrderChange('email')} style={{opacity: 0.6}} className={classes.tableColumnHeaderArrow}>
                            {<SortIconCustom className={classes.tableColumnHeaderSortIcon}/>}
                          </IconButton>
                        )}
                      </div>
                    </TableCell>
                    <TableCell><h4 className={classes.tableColumnHeaderText}><Entity entity="userRole" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnHeaderText}><Entity entity="userState" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnHeaderText}><Entity entity="actions" /></h4></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {_.map(installersData, (user) => {
                    const statusColor = !user.enabled ? '#E53935' : '#43A047';
                    return (
                      <TableRow
                        key={user.id}
                        className={classes.row}
                        hover
                        classes={{
                          selected: classes.rowSelected,
                          hover: classes.rowHovered,
                        }}
                        onClick={event => onSelectUser(user)}
                        selected={selectedUser && selectedUser.id === user.id}
                      >
                        <TableCell>
                          <div className={classes.guestRowContainer}>
                            <div>
                              <h5 style={{ fontWeight: 'bold', fontSize: 16 }}>{`${user.firstname} ${user.lastname}`}</h5>
                              <h5>{user.email}</h5>
                            </div>
                          </div>
                        </TableCell>
                        <TableCell>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                          {_.map(user.roles, (role) => {
                            const formattedRole = RolesActions.formatRole(role);
                            const isRoleGuest = role && role.id === 5;
                            return (
                              <div key={role.id} style={{ display: 'flex', marginRight: 10, marginTop: 5 }}>
                                {!isRoleGuest ? <RoleIcon style={{ color: '#3f3f3f', marginTop: 3, fontSize: 20 }} /> : <UsersIconCustom style={{ color: '#3f3f3f', marginTop: 3, width: 20 }} />}
                                <h5 className="card-description" style={{ margin: 5, fontWeight: 'bold', marginTop: 6 }}>{formattedRole.label}</h5>
                              </div>
                            );
                          })}
                        </div>
                        </TableCell>
                        <TableCell>
                          <div className={classes.rowWithAction}>
                            <div style={{ backgroundColor: statusColor, width: 8, height: 8, borderRadius: 50, marginRight: 5 }} />
                            <h5>
                              <Entity
                                key={`${user.enabled}`}
                                style={{ fontWeight: 'bold', textTransform: 'uppercase', color: statusColor, textAlign: 'center', fontSize: 12, margin: 0 }}
                                entity={!user.enabled ? 'userDisabled' : 'userEnabled'}
                              />
                            </h5>
                            {canEditUser && user.enabled ? (
                              <IconButton
                                onClick={(event) => {
                                  event.stopPropagation();
                                  onDisableUserRequest(user);
                                }}
                                className={classes.rowActionButton}
                              >
                                <UserDisableIconCustom className={classes.rowActionButtonIcon} style={{ width: 20, marginLeft: 2 }} />
                              </IconButton>
                            ) : null}
                            {canEditUser && !user.enabled ? (
                              <IconButton
                                onClick={(event) => {
                                  event.stopPropagation();
                                  onResetUserPassword(user);
                                }}
                                className={classes.rowActionButton}
                              >
                                <UserCheckIconCustom className={classes.rowActionButtonIcon} style={{ color: '#43A047', width: 20, marginLeft: 2 }} />
                              </IconButton>
                            ) : null}
                          </div>
                        </TableCell>
                        <TableCell>
                          {canDeleteUser ? (
                            <div className={classes.actionContainer}>
                              <Button
                                onClick={(event) => {
                                  event.stopPropagation();
                                  onDeleteUserRequest(user);
                                }}
                                className={classes.button}
                              >
                                <Entity entity="delete" />
                                <DeleteIcon style={{ fontSize: 15, marginLeft: 5 }} />
                              </Button>
                            </div>
                        ) : null}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                <TableFooter>
                  <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                    <TablePagination
                      colSpan={4}
                      count={!_.isUndefined(totalElements) ? totalElements : 0}
                      rowsPerPage={!_.isUndefined(size) ? size : 0}
                      page={!_.isUndefined(currentPage) ? currentPage : 0}
                      labelRowsPerPage=" "
                      classes={{
                        input: classes.disabledInput,
                      }}
                      labelDisplayedRows={({ from, to, count }) => (
                        <h4 className={classes.paginationText}>
                          <Entity
                            key={`${from}-${totalPages}-${count}`}
                            entity="userTablePagination"
                            data={{
                              currentPage: !_.isUndefined(currentPage) ? currentPage + 1 : 0,
                              totalPages: !_.isUndefined(totalPages) ? totalPages : 0,
                              count: !_.isUndefined(count) ? count : 0,
                            }}
                          />
                        </h4>
                      )}
                      onChangePage={(event, page) => onFetchInstallersOnPage(page)}
                      ActionsComponent={() => (
                        <MDTablePaginationActions
                          count={totalElements}
                          page={currentPage}
                          iconColor="#3f3f3f"
                          lastPage={totalPages - 1}
                          rowsPerPage={size}
                          onChangePage={(event, page) => onFetchInstallersOnPage(page)}
                        />
                      )}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
              <ReactTooltip delayShow={200} effect="float" />
            </Card>
            : (
              <div>
                {!viewLoading ? (
                  <EmptyView
                    title={filters && !filters.search ? 'noUser' : 'noUserFound'}
                    onNewEntity={canCreateUser ? () => onNewInstallerUser() : null}
                    newEntityTitle="addInstallerUser"
                    iconName="icon-simple-line-icons-user"
                  />) : <ListLoadingView />}
              </div>
            )}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(InstallersTableView);
